import React from 'react'
import '../App.css';
import { Navbar, LB_Header_gri, LB_Texto, Recomendados_LB, Descarga_LB, PuntosVenta_LB, Footer, NL_Descarga, NLV_Coleccion } from '../container';
import Home_cinco from "../container/LibroBl/libro_bl_more/Libro_bl_more";
import { useTranslation } from "react-i18next";

const LibroBl = () => {
  const [t, i18n] = useTranslation("librBlanc");

  return (
    <div class="App_DB">
      {i18n.language == 'es' ? (
        <>
          <Navbar link='https://www.amazon.com.mx/Ideas-Sobre-Libertad-Cambian-Mundo/dp/6079900653/ref=sr_1_2?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&keywords=ideas+sobre+la+libertad&qid=1678383847&sr=8-2' />
        </>) : (
        <>
          <Navbar link='https://www.amazon.com.mx/dp/B0DN7DNTWT?ref=cm_sw_r_cso_wa_apan_dp_BZF1C4P3T9BVYJ7XRF3F&ref_=cm_sw_r_cso_wa_apan_dp_BZF1C4P3T9BVYJ7XRF3F&social_share=cm_sw_r_cso_wa_apan_dp_BZF1C4P3T9BVYJ7XRF3F&skipTwisterOG=1' />
        </>
      )}

      <LB_Header_gri />

      <LB_Texto />

      <Descarga_LB />
      <NLV_Coleccion />
      <Home_cinco />
      <Footer />

    </div>
  )
}

export default LibroBl
